<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="equities-list-table">
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.equity.edit', params: { equityId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'equities-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    equities: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'begin', label: 'Data' },
        { key: 'name', label: 'Nome' },
        { key: 'typeName', label: 'Tipo' },
        { key: 'importo', label: 'Importo' },
      ];
    },
    tableRows () {
      return (this.equities || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>

<style lang="scss">

.equities-list-table {
  th {
    text-align: left;
  }

  tr {
    text-align: left;
  }

  .col-key-importo {
    text-align: right;
  }
}

</style>
